import urlParser from 'bloko/common/urlParser';

import paths from 'src/app/routePaths';
import { CriteriaKey } from 'src/types/search/common/criteria';
import { Criteria, LabelOption } from 'src/types/search/resume/criteria';

const SALARY_CRITERIA_KEYS = [CriteriaKey.SalaryFrom, CriteriaKey.SalaryTo, CriteriaKey.CurrencyCode];

export const getUrlWithVacancyFilters = (
    urlSearchParams: string,
    vacancySearchParams: Record<string, string>
): string => {
    const urlParsed = urlParser(paths.resumeSearch + urlSearchParams);
    const queryParams = { ...urlParsed.params, ...vacancySearchParams } as Partial<Criteria>;

    // if context vacancy has any salary filter - delete label `only_with_salary`
    const labelValues = queryParams[CriteriaKey.Label];
    if (labelValues && SALARY_CRITERIA_KEYS.some((key) => key in vacancySearchParams)) {
        const isNotOnlyWithSalary = (value: LabelOption) => value !== LabelOption.OnlyWithSalary;
        queryParams[CriteriaKey.Label] = labelValues.filter(isNotOnlyWithSalary);
    }

    urlParsed.params = queryParams;
    return urlParsed.href;
};
